/* 
 * Sessions List Block JS
 */

'use strict';

// Session List section type
jQuery( function( $ ) {


	/* 
	 * UPDATED Sessions List Block JS
	 */

	// All session triggers
	var $triggers = $( '.session-list .accordion-container .ac-trigger' );

	// Expand/Fold
	$( '#sessions-expand' ).click( function(){
		$triggers.each( function(){
			if ( ! $( this ).closest( '.ac' ).hasClass( 'is-active' ) ) {
				$( this ).trigger( 'click' );
			}
		});
		return false;
	});
	$( '#sessions-fold' ).click( function(){
		$triggers.each( function(){
			if ( $( this ).closest( '.ac' ).hasClass( 'is-active' ) ) {
				$( this ).trigger( 'click' );
			}
		});
		return false;
	});

	$( '.session-list' ).click( function(){
		setTimeout(function() {
			if ( $( '.session-list .accordion-container .ac' ).hasClass( 'is-active' ) ) {
				$( '#scroll-to-top-sessions' ).addClass( 'show' );
			} else {
				$( '#scroll-to-top-sessions' ).removeClass( 'show' );
			}
		}, 600);
	});

	$( '#scroll-to-top-sessions' ).click( function(){
		$('html, body').animate({
			scrollTop: $( '.sessions-list-block' ).offset().top
		}, 2000);
	});

	/* */


	var throttle = require( 'lodash.throttle' );
	var $body = $( 'body' );

	// Add a class that will make the scroll-to-top button visible on mobile (otherwise it
	// would be hidden by the 'Fold all' button)
	if ( $( '.content-section.type-session_list' ).length > 0 ) {
		$body.addClass( 'has-session-list' );
	}

	// Add/remove classes to show/hide controls depending on whether sections are open or closed
	var setControlClasses = function() {
		if ( $( '.session-group.is-open' ).length === 0 ) {
			$body.addClass( 'no-open-sections' );
		} else {
			$body.removeClass( 'no-open-sections' );
		}
		if ( $( '.session-group:not(.is-open)' ).length === 0 ) {
			$body.addClass( 'no-closed-sections' );
		} else {
			$body.removeClass( 'no-closed-sections' );
		}

	};

	// Set heights of expanded sections
	var recalculateHeights = function() {
		$( '.session-group' ).each( function() {
			var $group = $( this );
			var height = ( $group.is( '.is-open' ) ? $group.find( '.session-group-sessions' ).outerHeight() : 1 );
			console.log( $group, height );
			$group.find( '.session-group-sessions-wrapper' ).css( 'height', height );
		});
	};

	// Toggle sections when clicked
	$( '.session-group-title' ).on( 'click', function( e ) {
		e.preventDefault();
		$( this ).closest( '.session-group' ).toggleClass( 'is-open' );
		recalculateHeights();
		setControlClasses();
	});

	// Expand all sections
	$( '.session-list-controls .expand-all' ).on( 'click', function( e ) {
		e.preventDefault();
		$( this ).closest( '.content-section' ).find( '.session-group' ).addClass( 'is-open' );
		recalculateHeights();
		$body.removeClass( 'no-open-sections' );
		$body.addClass( 'no-closed-sections' );
	});

	// Fold all sections
	$( '.session-list-controls .fold-all' ).on( 'click', function( e ) {
		e.preventDefault();
		$( this ).closest( '.content-section' ).find( '.session-group' ).removeClass( 'is-open' );
		recalculateHeights();
		$body.addClass( 'no-open-sections' );
		$body.removeClass( 'no-closed-sections' );
	});

	// Recalculate heights of expanded sections when window is resized
	$( window ).on( 'resize', throttle( function() {
		$body.addClass( 'is-resizing' );
		recalculateHeights();
		$body.removeClass( 'is-resizing' );
	}, 10, { leading: false, trailing: true } ) );

	// Reposition expand/fold buttons when window is scrolled
	var minOffsetFromBrowserTop = 64;
	var listPaddingTop = 20;
	var listPaddingBottom = 27;
	var controlHeight = 58;
	$( window ).on( 'scroll', throttle( function() {
		var windowTop = $( this ).scrollTop();
		$( '.session-list-controls' ).each( function() {
			var $list = $( this ).offsetParent();
			var listTop = $list.offset().top;
			var listHeight = $list.outerHeight();
			var top = Math.max( 0, windowTop - listTop + minOffsetFromBrowserTop ) + listPaddingTop;
			top = Math.min( top, listHeight - controlHeight - listPaddingBottom );
			$( this ).css( 'top', top );
		});
	}, 10 ) );

	recalculateHeights();
	setControlClasses();
	// TODO: update the dropdown options for session type ACF field (current options don't match next conference's types)
});
